function onClickQuickView(button) {
  const parent = button.closest('[card-wrapper]');
  const modal = parent.querySelector('custom-quikview');
  const modalContent = modal.querySelector('[quickview-content]');
  const productUrl = button.getAttribute('data-url');

  if (!productUrl) return;

  // Close other open modals
  document.querySelectorAll('custom-quikview').forEach(openModal => {
    openModal.classList.remove('active');
    const openModalContent = openModal.querySelector('[quickview-content]');
    if (openModalContent) openModalContent.innerHTML = '';
  });

  document.body.classList.add('modal-open');
  modal.classList.add('active');
  modalContent.innerHTML = '<p>Loading...</p>';

  fetch(productUrl)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const productInfo = doc.querySelector('quickview-product-info');
      if (productInfo) {
        preventDuplicatedIDs(productInfo);
        preventVariantURLSwitching(productInfo);
        removeDOMElements(productInfo);

        HTMLUpdateUtility.setInnerHTML(modalContent, productInfo.outerHTML);
      } else {
        modalContent.innerHTML = '<p>Product info not found</p>';
      }
    })
    .catch(error => {
      console.error('Error:', error);
      modalContent.innerHTML = '<p>Error loading product info</p>';
    });
}


document.addEventListener('click', function (e) {

  // CLOSE QUICKVIEW
  const closeBtn = e.target.closest('[close-quickview]');
  if (closeBtn) {

    const activeModal = closeBtn.closest('custom-quikview');
    if (!activeModal) return;

    activeModal.classList.remove('active');

    const modalContent = activeModal.querySelector('[quickview-content]');
    if (modalContent) modalContent.innerHTML = '';

    document.body.classList.remove('modal-open');
  }

});



// articl page quick
const quickButtonsBlog = document.querySelectorAll('[custom-quikview-blog]');

quickButtonsBlog.forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();

    const productUrl = this.getAttribute('data-url');
    if (!productUrl) return;

    const originalParent = this.parentNode;

    // Check if already wrapped, if not create wrapper
    let wrapper = this.closest('.quick-wrap');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'quick-wrap';

      // Insert wrapper in original position and move button inside
      originalParent.insertBefore(wrapper, this);
      wrapper.appendChild(this);
    } else {
      // Remove old modal if exists
      const existingModal = wrapper.querySelector('.quick-add-popup');
      if (existingModal) existingModal.remove();
    }

    // Create modal inside wrapper
    const modal = document.createElement('custom-quikview-blog');
    modal.id = 'quickview-modal';
    modal.className = 'quickview-modal quick-add-popup';
    modal.innerHTML = `
      <button class="close-quickview" close-quickview-blog>×</button>
      <div class="quickview-content" quickview-content><p>Loading...</p></div>
    `;
    wrapper.appendChild(modal);

    // Fetch product info
    fetch(productUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const productInfo = doc.querySelector('quickview-product-info'); // Adjust selector
        preventDuplicatedIDs(productInfo);
        removeDOMElements(productInfo);
        preventVariantURLSwitching(productInfo)
        const modalContent = modal.querySelector('[quickview-content]');
        modalContent.innerHTML = productInfo ? productInfo.innerHTML : '<p>Product info not found</p>';
      })
      .catch(error => {
        console.error('Error:', error);
        modal.querySelector('[quickview-content]').innerHTML = '<p>Error loading product info</p>';
      });

    // Close button functionality
    modal.querySelector('[close-quickview-blog]').addEventListener('click', function () {
      // Move button back to original parent
      originalParent.insertBefore(button, wrapper);
      // Remove wrapper
      wrapper.remove();
    });
  });
});


 function preventVariantURLSwitching(productElement) {
    productElement.setAttribute('data-update-url', 'false');
  }

function preventDuplicatedIDs(productElement) {
    const sectionId = productElement.dataset.section;
    console.log("sectionId",sectionId)
    const oldId = sectionId;
    const newId = `quickadd-${sectionId}`;
    console.log("old",oldId)
  console.log("new",newId)
    productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
    Array.from(productElement.attributes).forEach((attribute) => {
      if (attribute.value.includes(oldId)) {
        productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
      }
    });

    productElement.dataset.originalSection = sectionId;
  }

function removeDOMElements(productElement) {
  // console.log(":productElement",productElement);

  const pickupAvailability = productElement.querySelector('pickup-availability');
  if (pickupAvailability) pickupAvailability.remove();

  const persnalData = productElement.querySelector('.person-info-container');
  if (persnalData) persnalData.remove();

  const media_gallery = productElement.querySelector('.product__media-wrapper');
  if (media_gallery) media_gallery.remove();

  const product_features = productElement.querySelector('.product_features');
  if (product_features) product_features.remove();

  const productModal = productElement.querySelector('product-modal');
  if (productModal) productModal.remove();

  const modalDialog = productElement.querySelectorAll('modal-dialog');
  if (modalDialog) modalDialog.forEach((modal) => modal.remove());
}


const accordionItems = document.querySelectorAll('[accordion]');

accordionItems.forEach((item, index) => {
  const title = item.querySelector('[accordion__title]');
  const content = item.querySelector('[faq_accordion__content]');

  if (index === 0) {
    item.classList.add('active');
    content.style.maxHeight = content.scrollHeight + 'px';
  } else {
    content.style.maxHeight = null;
  }

  title.addEventListener('click', function () {
    const isActive = item.classList.contains('active');

    accordionItems.forEach((otherItem) => {
      otherItem.classList.remove('active');
      otherItem.querySelector('[faq_accordion__content]').style.maxHeight = null;
    });

    if (!isActive) {
      item.classList.add('active');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
});




/*const tabNavItems = document.querySelectorAll(".tab-nav-title");
const tabContents = document.querySelectorAll(".tabs-content-wrapper");

if (tabNavItems.length && tabContents.length) {
  tabNavItems.forEach((tab, index) => {
    const link = tab.querySelector("a");
    if (index === 0) {
      tab.classList.add("active");
      if (link) {
        link.classList.remove("button--secondary");
        link.classList.add("button--primary");
      }
      tabContents[index].style.display = "block";
    } else {
      if (link) {
        link.classList.remove("button--primary");
        link.classList.add("button--secondary");
      }
      tabContents[index].style.display = "none";
    }
  });

  tabNavItems.forEach((tab, index) => {
    const link = tab.querySelector("a");
    if (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        tabNavItems.forEach((t, i) => {
          const tLink = t.querySelector("a");
          t.classList.remove("active");
          if (tLink) {
            tLink.classList.remove("button--primary");
            tLink.classList.add("button--secondary");
          }
          tabContents[i].style.display = "none";
        });

        tab.classList.add("active");
        link.classList.remove("button--secondary");
        link.classList.add("button--primary");
        tabContents[index].style.display = "block";
      });
    }
  });
} */

  document.querySelectorAll(".tabs-main-wrapper").forEach((tabsWrapper) => {
  const tabNavItems = tabsWrapper.querySelectorAll(".tab-nav-title");
  const tabContents = tabsWrapper.querySelectorAll(".tabs-content-wrapper");

  if (!tabNavItems.length || !tabContents.length) return;

  tabNavItems.forEach((tab, index) => {
    const link = tab.querySelector("a");

    if (index === 0) {
      tab.classList.add("active");
      if (link) {
        link.classList.remove("button--secondary");
        link.classList.add("button--primary");
      }
      if (tabContents[index]) {
        tabContents[index].style.display = "block";
      }
    } else {
      if (link) {
        link.classList.remove("button--primary");
        link.classList.add("button--secondary");
      }
      if (tabContents[index]) {
        tabContents[index].style.display = "none";
      }
    }
  });

  tabNavItems.forEach((tab, index) => {
    const link = tab.querySelector("a");

    if (!link) return;

    link.addEventListener("click", function (e) {
      e.preventDefault();

      tabNavItems.forEach((t, i) => {
        const tLink = t.querySelector("a");
        t.classList.remove("active");

        if (tLink) {
          tLink.classList.remove("button--primary");
          tLink.classList.add("button--secondary");
        }

        if (tabContents[i]) {
          tabContents[i].style.display = "none";
        }
      });

      tab.classList.add("active");
      link.classList.remove("button--secondary");
      link.classList.add("button--primary");

      if (tabContents[index]) {
        tabContents[index].style.display = "block";
      }

      setTimeout(() => {
        if (window.jdgm && typeof window.jdgm.refreshWidgets === "function") {
          window.jdgm.refreshWidgets();
        } else if (window.jdgmShopify && typeof window.jdgmShopify.loadWidgets === "function") {
          window.jdgmShopify.loadWidgets();
        }
      }, 150);
    });
  });
});

// const visibleParagraphs = 1;

// document.querySelectorAll(".tabs-content-wrapper").forEach(function(tabWrapper) {
//   const textContainer = tabWrapper.querySelector(".tabs-content-text");
//   const paragraphs = textContainer ? textContainer.querySelectorAll("p") : [];

//   if (paragraphs.length > visibleParagraphs) {
//     paragraphs.forEach((p, i) => {
//       if (i >= visibleParagraphs) {
//         p.style.display = "none";
//         p.classList.add("extra-paragraph");
//       }
//     });

//     const btn = document.createElement("button");
//     btn.className = "see-more-btn";
//     btn.textContent = "Weiterlesen";
//     textContainer.parentNode.appendChild(btn);

//     btn.addEventListener("click", function () {
//       const hiddenParas = tabWrapper.querySelectorAll(".extra-paragraph");
//       const isHidden = hiddenParas[0].style.display === "none";

//       hiddenParas.forEach(p => {
//         p.style.display = isHidden ? "block" : "none";
//       });

//       btn.textContent = isHidden ? "Weniger anzeigen" : "Weiterlesen";
//     });
//   }
// });




document.querySelectorAll("[review_click]").forEach(function (link) {

    link.addEventListener("click", function (e) {
        console.log("linkssss",link);
      const target = document.querySelector("#review_data a");
      if (target) {
        target.click(); // target element par click trigger thase

        target.scrollIntoView({
          behavior: "smooth", // smooth scrolling
          block: "start"
        });
      }
    });
  });


  // accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };

  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };

  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {

            if (!accordion.closest('.mobile-facets-blog-inner')) {
              accordions.forEach((accordion) => closeAccordion(accordion));
            }

            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });
}
// accordions js end
(function() {
  faq_taggol();
})();

class BlogDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.main-blog-section');

    this.borderOffset =
      this.borderOffset ||
      (this.closest('.header-wrapper')?.classList.contains('header-wrapper--border-bottom') ? 1 : 0);

    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );

    this.header.classList.add('blog-drawer-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('blog-drawer-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('blog-drawer-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    if (this.header) {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    }
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

// scroll and load more btn trigger click on collection page

// document.addEventListener("DOMContentLoaded", function () {
//   const container = document.querySelector('[data-pagination-link]');

//   if (!container) return;

//   function checkAndClickButton() {
//     const loadMoreBtn = container.querySelector('[data-pagination-btn]');
//     if (!loadMoreBtn) return;

//     const observer = new IntersectionObserver(
//       (entries, obs) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             // Click the button
//             loadMoreBtn.click();
//             // Stop observing this button instance
//             obs.unobserve(loadMoreBtn);
//             // Check again after a short delay to handle the next button
//             setTimeout(checkAndClickButton, 500);
//           }
//         });
//       },
//       {
//         root: null,
//         rootMargin: "0px",
//         threshold: 0.1,
//       }
//     );

//     observer.observe(loadMoreBtn);
//   }

//   // Initial call
//   checkAndClickButton();
// });
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector('[data-pagination-link]');
  if (!container) return;

  let isLoading = false;

  function observeButton() {
    const loadMoreBtn = container.querySelector('[data-pagination-btn]');
    if (!loadMoreBtn || isLoading) return;

    // Button visible na hoy to pan observer work kare
    loadMoreBtn.style.display = 'block';
    loadMoreBtn.style.visibility = 'hidden';

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isLoading) {
            isLoading = true;

            // Trigger pagination
            loadMoreBtn.click();

            // Stop observing current button
            obs.unobserve(loadMoreBtn);

            // Wait for new products & next button
            setTimeout(() => {
              isLoading = false;
              observeButton();
            }, 500);
          }
        });
      },
      {
        root: null,
        rootMargin: "200px",
        threshold: 0,
      }
    );

    observer.observe(loadMoreBtn);
  }

  // Start infinite scroll
  observeButton();
});



// blog page filter logic

document.addEventListener("DOMContentLoaded", function () {

  const checkboxes = document.querySelectorAll(".blog-filter-checkbox");
  const resetBtn = document.querySelector(".reset-blog");
  const showBlogResult = document.querySelector(".show-blog-result");
  const allResultContainer = document.querySelector(".all-result");
  const blankEl = document.querySelector(".blank-filter-text");
  const articleCountEl = document.querySelector("[data-article-count]");
  const wrapper = document.querySelector("[data-product-main-wrapper]");
  const paginationWrapper = document.querySelector("[data-pagination-link]");

  if (!wrapper || !articleCountEl) return;

  let currentPage = 1;
  let isLoading = false;

  const countSuffix = articleCountEl.textContent.replace(/\d+/g, "").trim();

  /* ---------------------------------------------------
     MULTI SELECTION PER GROUP
  --------------------------------------------------- */
  document.querySelectorAll("[js-acc-item]").forEach(group => {
    const groupCheckboxes = group.querySelectorAll(".blog-filter-checkbox");

    groupCheckboxes.forEach(cb => {
      cb.addEventListener("change", () => {
        showSelectedFilters();
        applyFilters();
      });
    });
  });

  /* ---------------------------------------------------
     SHOW SELECTED TAGS
  --------------------------------------------------- */
  function showSelectedFilters() {
    allResultContainer.innerHTML = "";
    const selected = [...checkboxes].filter(cb => cb.checked);

    if (!selected.length) {
      showBlogResult.classList.add("hidden");
      return;
    }

    showBlogResult.classList.remove("hidden");

    selected.forEach(cb => {
      const tag = document.createElement("span");
      tag.className = "selected-tag";
      tag.innerHTML = `${cb.dataset.title}
        <span class="remove-tag" data-tag="${cb.value}">✕</span>`;
      allResultContainer.appendChild(tag);
    });
  }

  /* ---------------------------------------------------
     REMOVE TAG
  --------------------------------------------------- */
  allResultContainer.addEventListener("click", e => {
    if (!e.target.classList.contains("remove-tag")) return;

    const val = e.target.dataset.tag;
    const cb = [...checkboxes].find(c => c.value === val);

    if (cb) {
      cb.checked = false;
    }

    showSelectedFilters();
    applyFilters();
  });

  /* ---------------------------------------------------
     RESET ALL FILTERS
  --------------------------------------------------- */
  resetBtn?.addEventListener("click", () => {
    checkboxes.forEach(cb => {
      cb.checked = false;
    });
    showSelectedFilters();
    applyFilters();
  });

  /* ---------------------------------------------------
     APPLY FILTER (AJAX)
  --------------------------------------------------- */
  function applyFilters() {
    currentPage = 1;

    const tags = [...checkboxes]
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    const base = location.pathname.split("/tagged/")[0];
    const url = tags.length
      ? `${base}/tagged/${tags.join(",")}`
      : base;

    history.pushState(null, "", url);
    fetchPage(url, false, tags); // pass tags to update count
  }

  /* ---------------------------------------------------
     FETCH PAGE
  --------------------------------------------------- */
  function fetchPage(url, append = false, tags = []) {
    if (isLoading) return;
    isLoading = true;
    wrapper.classList.add("is-loading");

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newWrapper = doc.querySelector("[data-product-main-wrapper]");
        const bredcums = doc.querySelector("#bredcurum_main");
        if (!newWrapper) return;

        const newArticles = newWrapper.querySelector(".blog-articles");
        const currentArticles = wrapper.querySelector(".blog-articles");
        const exit_bredcurm = document.querySelector("#bredcurum_main");

        if (!append) {
          wrapper.innerHTML = newWrapper.innerHTML;
        } else if (newArticles && currentArticles) {
          currentArticles.insertAdjacentHTML("beforeend", newArticles.innerHTML);
        }

        if(bredcums) exit_bredcurm.innerHTML = bredcums.innerHTML;

        // 🔹 RESET ALL ACCORDIONS
        document.querySelectorAll("[js-acc-item]").forEach(item => {
          item.classList.remove("active");
          const content = item.querySelector("[js-acc-single-content]");
          if (content) content.style.maxHeight = "";
        });

        // 🔹 UPDATE TOTAL COUNT FROM SERVER
        updateCount(tags, doc);

        updatePagination(doc);

        wrapper.classList.remove("is-loading");
        isLoading = false;
      })
      .catch(() => {
        wrapper.classList.remove("is-loading");
        isLoading = false;
      });
  }

  /* ---------------------------------------------------
     COUNT UPDATE
     🔹 Always fetch total count from server
  --------------------------------------------------- */
function updateCount(selectedTags = [], doc = null) {

  function applyCount(totalCount) {
    const count = isNaN(totalCount) ? 0 : totalCount;

    articleCountEl.textContent = `${count} ${countSuffix}`;

    if (count > 0) {
      blankEl.style.display = "none";
      articleCountEl.style.display = "block";
    } else {
      blankEl.style.display = "block";
      articleCountEl.style.display = "none";
    }
  }

  /* -------------------------------
     IF DOC NOT PASSED → FETCH PAGE
  --------------------------------*/
  if (!doc) {

    const base = location.pathname.split("/tagged/")[0];
    const tags = [...checkboxes]
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    const url = tags.length
      ? `${base}/tagged/${tags.join(",")}`
      : base;

    fetch(url)
      .then(res => res.text())
      .then(html => {

        const parsed = new DOMParser().parseFromString(html, "text/html");

        const totalCountEl = parsed.querySelector("[data-article-count]");

        let totalCount = 0;

        if (totalCountEl) {
          const text = totalCountEl.textContent.trim();
          const match = text.match(/\d+/);
          totalCount = match ? parseInt(match[0], 10) : 0;
        }

        applyCount(totalCount);

      })
      .catch(() => applyCount(0));

    return;
  }

  /* -------------------------------
     DOC PASSED → USE DIRECT COUNT
  --------------------------------*/
  const totalCountEl = doc.querySelector("[data-article-count]");

  let totalCount = 0;

  if (totalCountEl) {
    const text = totalCountEl.textContent.trim();
    const match = text.match(/\d+/);
    totalCount = match ? parseInt(match[0], 10) : 0;
  }

  applyCount(totalCount);
}
  /* ---------------------------------------------------
     PAGINATION UPDATE
  --------------------------------------------------- */
  function updatePagination(doc) {
    if (!paginationWrapper) return;

    const newPagination = doc.querySelector("[data-pagination-link]");
    if (!newPagination || !newPagination.innerHTML.trim()) {
      paginationWrapper.style.display = "none";
      return;
    }

    paginationWrapper.innerHTML = newPagination.innerHTML;
    paginationWrapper.style.display = "block";
  }

  /* ---------------------------------------------------
     PAGINATION CLICK (AJAX)
  --------------------------------------------------- */
  document.addEventListener("click", e => {
    const btn = e.target.closest("[data-pagination-btn]");
    if (!btn) return;

    e.preventDefault();
    if (isLoading) return;

    currentPage++;

    const tags = [...checkboxes]
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    const base = location.pathname.split("/tagged/")[0];
    const url = tags.length
      ? `${base}/tagged/${tags.join(",")}?page=${currentPage}`
      : `${base}?page=${currentPage}`;

    fetchPage(url, true, tags);
  });

  /* ---------------------------------------------------
  //    INITIAL
  // --------------------------------------------------- */
   showSelectedFilters();
   updateCount(); // fetch total count initially
});

// blog page filter logic for the mobile

document.addEventListener("DOMContentLoaded", function () {

  const checkboxes = document.querySelectorAll(".mobile-filter-checkbox");
  const resetBtn = document.querySelector(".reset-blog");
  const showBlogResult = document.querySelector(".show-blog-result");
  const allResultContainer = document.querySelector(".all-result");
  const blankEl = document.querySelector(".blank-filter-text");
  const articleCountEl = document.querySelector("[data-mobile-count]");
  const wrapper = document.querySelector("[data-product-main-wrapper]");
  const paginationWrapper = document.querySelector("[data-pagination-link]");

  if (!wrapper || !articleCountEl) return;

  let currentPage = 1;
  let isLoading = false;

  const countSuffix = articleCountEl.textContent.replace(/\d+/g, "").trim();

  /* ---------------------------------------------------
     MULTI SELECTION PER GROUP
  --------------------------------------------------- */
  document.querySelectorAll("[js-acc-item]").forEach(group => {
    const groupCheckboxes = group.querySelectorAll(".mobile-filter-checkbox");

    groupCheckboxes.forEach(cb => {
      cb.addEventListener("change", () => {
        showSelectedFilters();
      });
    });
  });

  // Apply filter btn for the mobile
    const applyBtn = document.querySelector(".filter-apply");
    applyBtn?.addEventListener("click", function () {

      const tags = [...checkboxes]
        .filter(cb => cb.checked)
        .map(cb => cb.value);

      const base = location.pathname.split("/tagged/")[0];

      const url = tags.length
        ? `${base}/tagged/${tags.join(",")}`
        : base;

      // 🔹 URL redirect + page reload
      window.location.href = url;

    });

    function showSelectedFilters (){

        const drawerSelected = document
            .querySelector(`.Mobile-Drawer-Selected-Filters`)

        if( drawerSelected )
            drawerSelected.innerHTML = ''

        const selected = [ ... checkboxes ]
            .filter(( checkbox ) => checkbox.checked )

        document
        .querySelectorAll(`.Group-Reset-Button`)
        .forEach(( button ) => {

            const hasChecked = [ ... checkboxes ]
                .some(( checkbox ) => checkbox.checked &&
                    checkbox.dataset.group === button.dataset.group)

            button.style.display = hasChecked
                ? 'inline-block' : 'none'
        })

        if( ! drawerSelected )
            return

        drawerSelected.style.display =
            ( selected.length ) ? 'block' : 'none'

        if( ! selected.length )
            return

        selected.forEach(( checkbox ) => {

            const tag = document.createElement('span')
            tag.className = 'Mobile-Selected-Tag'
            tag.innerHTML = `
                ${ checkbox.dataset.group }: ${ checkbox.dataset.title }
                <span
                    data-tag = '${ checkbox.value }'
                    class = 'remove-tag'
                >x</span>
            `

            drawerSelected.appendChild(tag)
        })
    }


    [
        document.querySelector(`.mobile-facets-blog-inner`) ,
        allResultContainer
    ].forEach(( element ) => {
        element?.addEventListener('click',( event ) => {

            const { target } = event

            if( ! target.classList.contains('remove-tag') )
                return

            const tag = target.dataset.tag

            const checkbox = [ ... checkboxes ]
                .find(( checkbox ) => checkbox.value === tag )

            if( checkbox )
                checkbox.checked = false

            showSelectedFilters()
        })
    })


    document
    .querySelectorAll(`.Group-Reset-Button`)
    .forEach(( button ) => {

        button.addEventListener('click',( event ) => {

            event.stopPropagation()

            const group = button.dataset.group

            checkboxes
            .filter(( checkbox ) => checkbox.dataset.group === group )
            .forEach(( checkbox ) => checkbox.checked = false )

            showSelectedFilters()
        })
    })

  /* ---------------------------------------------------
     RESET ALL FILTERS
  --------------------------------------------------- */
  resetBtn?.addEventListener("click", () => {
    checkboxes.forEach(cb => {
      cb.checked = false;
    });
    showSelectedFilters();
    applyFilters();
  });

  /* ---------------------------------------------------
     APPLY FILTER (AJAX)
  --------------------------------------------------- */
  function applyFilters() {
    currentPage = 1;

    const tags = [...checkboxes]
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    const base = location.pathname.split("/tagged/")[0];
    const url = tags.length
      ? `${base}/tagged/${tags.join(",")}`
      : base;

    history.pushState(null, "", url);
    fetchPage(url, false, tags); // pass tags to update count
  }

  /* ---------------------------------------------------
     FETCH PAGE
  --------------------------------------------------- */
  function fetchPage(url, append = false, tags = []) {
    if (isLoading) return;
    isLoading = true;
    wrapper.classList.add("is-loading");

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newWrapper = doc.querySelector("[data-product-main-wrapper]");
        const bredcums = doc.querySelector("#bredcurum_main");
        if (!newWrapper) return;

        const newArticles = newWrapper.querySelector(".blog-articles");
        const currentArticles = wrapper.querySelector(".blog-articles");
        const exit_bredcurm = document.querySelector("#bredcurum_main");

        if (!append) {
          wrapper.innerHTML = newWrapper.innerHTML;
        } else if (newArticles && currentArticles) {
          currentArticles.insertAdjacentHTML("beforeend", newArticles.innerHTML);
        }

        if(bredcums) exit_bredcurm.innerHTML = bredcums.innerHTML;

        // 🔹 RESET ALL ACCORDIONS
        document.querySelectorAll("[js-acc-item]").forEach(item => {
          item.classList.remove("active");
          const content = item.querySelector("[js-acc-single-content]");
          if (content) content.style.maxHeight = "";
        });

        // 🔹 UPDATE TOTAL COUNT FROM SERVER
        updateCount(tags, doc);

        updatePagination(doc);

        wrapper.classList.remove("is-loading");
        isLoading = false;
      })
      .catch(() => {
        wrapper.classList.remove("is-loading");
        isLoading = false;
      });
  }

  /* ---------------------------------------------------
     COUNT UPDATE
     🔹 Always fetch total count from server
  --------------------------------------------------- */
function updateCount(selectedTags = [], doc = null) {

  function applyCount(totalCount) {
    const count = isNaN(totalCount) ? 0 : totalCount;

    articleCountEl.textContent = `${count} ${countSuffix}`;

    if (count > 0) {
      blankEl.style.display = "none";
      articleCountEl.style.display = "block";
    } else {
      blankEl.style.display = "block";
      articleCountEl.style.display = "none";
    }
  }

  /* -------------------------------
     IF DOC NOT PASSED → FETCH PAGE
  --------------------------------*/
  if (!doc) {

    const base = location.pathname.split("/tagged/")[0];
    const tags = [...checkboxes]
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    const url = tags.length
      ? `${base}/tagged/${tags.join(",")}`
      : base;

    fetch(url)
      .then(res => res.text())
      .then(html => {

        const parsed = new DOMParser().parseFromString(html, "text/html");

        const totalCountEl = parsed.querySelector("[data-mobile-count]");

        let totalCount = 0;

        if (totalCountEl) {
          const text = totalCountEl.textContent.trim();
          const match = text.match(/\d+/);
          totalCount = match ? parseInt(match[0], 10) : 0;
        }

        applyCount(totalCount);

      })
      .catch(() => applyCount(0));

    return;
  }

  /* -------------------------------
     DOC PASSED → USE DIRECT COUNT
  --------------------------------*/
  const totalCountEl = doc.querySelector("[data-mobile-count]");

  let totalCount = 0;

  if (totalCountEl) {
    const text = totalCountEl.textContent.trim();
    const match = text.match(/\d+/);
    totalCount = match ? parseInt(match[0], 10) : 0;
  }

  applyCount(totalCount);
}
  /* ---------------------------------------------------
     PAGINATION UPDATE
  --------------------------------------------------- */
  function updatePagination(doc) {
    if (!paginationWrapper) return;

    const newPagination = doc.querySelector("[data-pagination-link]");
    if (!newPagination || !newPagination.innerHTML.trim()) {
      paginationWrapper.style.display = "none";
      return;
    }

    paginationWrapper.innerHTML = newPagination.innerHTML;
    paginationWrapper.style.display = "block";
  }

  /* ---------------------------------------------------
     PAGINATION CLICK (AJAX)
  --------------------------------------------------- */
  document.addEventListener("click", e => {
    const btn = e.target.closest("[data-pagination-btn]");
    if (!btn) return;

    e.preventDefault();
    if (isLoading) return;

    currentPage++;

    const tags = [...checkboxes]
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    const base = location.pathname.split("/tagged/")[0];
    const url = tags.length
      ? `${base}/tagged/${tags.join(",")}?page=${currentPage}`
      : `${base}?page=${currentPage}`;

    fetchPage(url, true, tags);
  });

  /* ---------------------------------------------------
  //    INITIAL
  // --------------------------------------------------- */
   showSelectedFilters();
   updateCount(); // fetch total count initially
});// end mobile


// blog rexept page link for the mobile
document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(".rk_has_link");

  links.forEach(function (element) {
    element.addEventListener("click", function (e) {

      const parentLi = this.closest("li");
      if (!parentLi) return;

      const target = parentLi.querySelector(".rk_print_hide");
      if (!target) return;

      const isAlreadyActive = target.classList.contains("print-btn");

      // Remove class from all first
      document.querySelectorAll(".rk_print_hide").forEach(function (el) {
        el.classList.remove("print-btn");
      });

      if (!isAlreadyActive) {
        // First click → prevent redirect + add class
        e.preventDefault();
        target.classList.add("print-btn");
      }
      // Second click → no preventDefault → redirect will work
    });
  });
});
